import { select, put } from 'redux-saga/effects';
import { getSelectedTimelines } from '../../../selectors';
import { scheduleActions } from '../../../actions';
import { PusherActionType, PusherReduxAction } from '../../../../../../../../redux/pusher/PusherActions';
import { selectExtensionPeriodEntriesSaga } from '../../../selectors-saga';

export function* handleExtensionPeriodEntryDelete(action: PusherReduxAction<PusherActionType.EXTENSION_PERIOD_DELETED>) {
  const selectedTimelines = yield select(getSelectedTimelines);

  if (!selectedTimelines || selectedTimelines.length === 0) {
    return;
  }

  const extensionEntries = yield* selectExtensionPeriodEntriesSaga();
  const deletedId = action.payload;

  const updatedEntries = extensionEntries.filter((entry: any) => entry.ID !== deletedId);

  yield put(scheduleActions.setExtensionPeriodTimelineEntries(updatedEntries));
}
